// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination-item_root__vZwo_","number":"pagination-item_number__EHAtY","current":"pagination-item_current__1nKFQ","truncation":"pagination-item_truncation__OXiGu"};